import script from "./StudioTour.vue?vue&type=script&setup=true&lang=js"
export * from "./StudioTour.vue?vue&type=script&setup=true&lang=js"

import "./StudioTour.vue?vue&type=style&index=0&id=11a9fe98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11a9fe98"]])

export default __exports__